module.exports = __webpack_public_path__ + "img/icon-ppt.7f6dafc6.svg";